import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacySnackBarModule as MatSnackBarModule } from '@angular/material/legacy-snack-bar';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatDividerModule } from '@angular/material/divider';
import { TemporaryComponent } from './temporary/temporary.component';
import { MatToolbarModule } from '@angular/material/toolbar';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatBadgeModule } from '@angular/material/badge';
import { MenuListComponent } from './sidebar/menu-list/menu-list.component';
import { MatLegacyChipsModule as MatChipsModule } from '@angular/material/legacy-chips';
import { MatRippleModule } from '@angular/material/core';
import { ErrorHandlerModule } from './system/error-handler/error-handler.module';
import { DetectDeviceService } from './system/services/detect-device.service';
import { AppInitializerService } from './app-initializer.service';
import { CommonFunctionService } from './system/services/common-function.service';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { MatLegacyAutocompleteModule as MatAutocompleteModule } from '@angular/material/legacy-autocomplete';
import { MatLegacyListModule as MatListModule } from '@angular/material/legacy-list';
import { ChipsModule } from './components/chips/chips.module';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { DirectivesModule } from './system/directives/directives.module';
import { ComponentsModule } from './components/components.module';
import { MatAnimatedIconModule } from './components/mat-animated-icon/mat-animated-icon.module';
import { PipeModule } from './system/pipes/pipe.module';
import { GlobalFunctionService } from './system/services/global-function.service';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CacheService } from './system/services/cache.service';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { ServiceWorkerModule } from '@angular/service-worker';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { environment } from '../environments/environment';
import { ServiceWorkerService } from './system/services/service-worker.service';
import { ImportComponent } from './modules/import/import.component';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
@NgModule({
    declarations: [
        AppComponent,
        TemporaryComponent,
        HeaderComponent,
        FooterComponent,
        SidebarComponent,
        MenuListComponent,
        // ImportComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule,
        FlexLayoutModule,
        MatButtonModule,
        MatIconModule,
        PipeModule,
        MatSnackBarModule,
        RouterModule,
        ErrorHandlerModule,
        MatDividerModule,
        MatToolbarModule,
        MatSidenavModule,
        MatBadgeModule,
        MatRippleModule,
        MatChipsModule,
        MatListModule,
        MatAutocompleteModule,
        MatTooltipModule,
        ChipsModule,
        MatSelectModule,
        DirectivesModule,
        ComponentsModule,
        MatAnimatedIconModule,
        MatCheckboxModule,
        ScrollingModule,
        ClipboardModule,
        MatProgressSpinnerModule,
        MatDialogModule,
        ServiceWorkerModule.register('service-worker.js', { enabled: environment.production })
    ],
    providers: [
        CommonFunctionService,
        GlobalFunctionService,
        DetectDeviceService,
        {
            provide: LocationStrategy,
            useClass: HashLocationStrategy
        },
        AppInitializerService,
        {
            provide: APP_INITIALIZER,
            useFactory: (configService: AppInitializerService) => () => configService.preLoad(),
            deps: [AppInitializerService],
            multi: true
        },
        ServiceWorkerService,
        CacheService
    ],
    bootstrap: [AppComponent],
    exports: []
})
export class AppModule { }
